module.exports = "https://www.gc-pro.gnp.com.mx/7f991dcfb0782ff388ed5561afd9dd2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/CodigoQROriginal.png
// module id = 8051
// module chunks = 0